import React from 'react';
import { Radio, Space } from 'antd';
import ReactCountryFlag from 'react-country-flag';
import { RadioBtn } from '../SettingsOverlay/SettingsOverlay.styles';
import { useLanguage } from '@app/hooks/useLanguage';

export const LanguagePicker: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const onChangeLanguage = (e) => {
    setLanguage(e.target.value);
  };
  return (
    <Radio.Group defaultValue={language} onChange={onChangeLanguage}>
      <Space direction="vertical">
        <RadioBtn value="en">
          <Space align="center">
            English
            <ReactCountryFlag svg countryCode="GB" />
          </Space>
        </RadioBtn>
        <RadioBtn value="vi">
          <Space align="center">
            Vietnamese
            <ReactCountryFlag svg countryCode="VN" />
          </Space>
        </RadioBtn>
      </Space>
    </Radio.Group>
  );
};
